import React from "react"
import { Box, Flex, Text } from "rebass"

const BookPreviewGrid = () => (
  <Box
    sx={{ borderColor: "text" }}
    css={{ borderTop: "2px solid", borderBottom: "2px solid" }}
  >
    <Flex>
      <Flex
        css={{ borderRight: "2px solid" }}
        sx={{ borderColor: "text" }}
        alignItems="center"
        justifyContent="center"
        p={[2, 3]}
        flex={[0.5, 1]}
      >
        <Text variant="gridItem">Hardcover</Text>
      </Flex>
      <Flex alignItems="center" justifyContent="center" px={[1, 3]} flex={1}>
        <Text variant="gridItem">MCD × FSG, 2019</Text>
      </Flex>
      <Flex
        css={{ borderLeft: "2px solid" }}
        sx={{ borderColor: "text" }}
        alignItems="center"
        justifyContent="center"
        p={[2, 3]}
        flex={[0.5, 1]}
      >
        <Text variant="gridItem">$27.00</Text>
      </Flex>
    </Flex>
  </Box>
)

export default BookPreviewGrid
